export default __webpack_public_path__ + "static/media/edit.5948f64b.svg";